import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useAnimateCss from "../../hooks/useAnimateCss";
import aboutImg from "../../assets/images/misc/why-choose-us.webp";

function AboutPreview() {
  const { t } = useTranslation();
  const imgRef    = useAnimateCss("animate__fadeInLeft",  0,   0.12);
  const badgeRef  = useAnimateCss("animate__bounceIn",    500, 0.12);
  const labelRef  = useAnimateCss("animate__fadeInDown",  0,   0.12);
  const headRef   = useAnimateCss("animate__fadeInUp",    120, 0.12);
  const paraRef   = useAnimateCss("animate__fadeInUp",    220, 0.12);
  const blocksRef = useAnimateCss("animate__fadeInUp",    340, 0.12);
  const btnRef    = useAnimateCss("animate__fadeInUp",    460, 0.12);

  return (
    <section className="about-preview-section">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* LEFT — image panel */}
          <div className="col-lg-6 order-lg-1 order-2" ref={imgRef as any}>
            <div className="about-image-panel" style={{ position: "relative" }}>
              <img src={aboutImg} alt="About Al Madina Steel" />
              <div
                ref={badgeRef as any}
                style={{
                  position: "absolute",
                  bottom: 0,
                  width: 140,
                  height: 100,
                  backgroundColor: "#041122",
                  borderTop: "4px solid white",
                  borderRight: "4px solid white",
                  borderTopRightRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "white",
                  fontSize: "17px",
                  fontWeight: 700,
                  lineHeight: 1.2,
                  letterSpacing: "0.04em",
                  padding: "4px",
                }}
              >
                50 YEARS OF EXPERT
              </div>
            </div>
          </div>

          {/* RIGHT — text */}
          <div className="col-lg-6 order-lg-2 order-1">
            <span className="section-label" ref={labelRef as any}>{t("Who We Are")}</span>
            <h2 className="about-heading" ref={headRef as any}>{t("Steel-based Future")}</h2>
            <p className="mt-3 mb-3" ref={paraRef as any}>{t("whoweare-text1")}</p>
            <div
              className="d-flex justify-content-between align-content-center gap-4"
              ref={blocksRef as any}
            >
              <div className="about-block">
                <span className="about-accent-label">{t("Our Vision")}</span>
                <p>{t("vision-info")}</p>
              </div>
              <div className="about-block">
                <span className="about-accent-label">{t("Our Mission")}</span>
                <p>{t("mission_text_intro")}</p>
              </div>
            </div>
            <div ref={btnRef as any} className="d-inline-block mt-4">
              <Link to="/who-we-are" className="btn-primary-custom">
                {t("Know More")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPreview;
